/* global window */

import './TestAssociations.scss';
import template from './TestAssociations.vhtml';

export default {
	name: 'TestAssociations',
	template: template,
	props: {
		number: {
			type: String
		},
		link: {
			type: Object
		},
	},
	data: () => ({
		lang: window.siteData.language || 'da',
	}),
};
